import { normalizeTournamentData } from '@sportal365/smp-widget-normalizers';
import { getTeamWinnerForm } from '@sportal365/smp-widget-utils';
import { SHORT_NAME } from '../../../../packages/constants/nameTypes';
import {
  IFootballConfig,
  IMatchH2H,
  INormalizedFootballGameData,
  INormalizedTournamentData,
  ITournamentMatchesH2H,
} from '../../../../packages/types';
import { H2HFilters } from '../widgets';
import { normalizeFootballMatchesH2HGameData } from './normalizeFootballMatchesH2HGameData';

interface INormalizeFootballTournamentResponseDataArgs {
  matchesGroupedByTournament?: ITournamentMatchesH2H[];
  matches?: IMatchH2H[];
  dataLabels?: IFootballConfig['dataLabels'];
  dataEntityLinks?: IFootballConfig['dataEntityLinks'];
  dataTeamNameType?: IFootballConfig['dataTeamNameType'];
  filter: string;
  teamId?: string;
}

type INormalizedFootballMatchesH2HResponseData =
  | {
      matches: {
        info: INormalizedFootballGameData | undefined;
      }[];
      tournament: INormalizedTournamentData | undefined;
    }[]
  | undefined;

export const normalizeFootballMatchesH2HResponseData = ({
  matchesGroupedByTournament,
  matches,
  dataEntityLinks,
  dataTeamNameType,
  filter,
  dataLabels,
  teamId,
}: INormalizeFootballTournamentResponseDataArgs): INormalizedFootballMatchesH2HResponseData => {
  if (filter === H2HFilters.H2H) {
    if (!matchesGroupedByTournament || matchesGroupedByTournament.length === 0) return;

    if (matchesGroupedByTournament && matchesGroupedByTournament.length > 0) {
      const normalizedMatchesGroupedByTournament = matchesGroupedByTournament.map(({ tournament, matches }) => {
        const normalizedMatches = matches.map((match: IMatchH2H) => ({
          info: normalizeFootballMatchesH2HGameData({
            game: match,
            dataEntityLinks,
            dataShortStatusType: SHORT_NAME,
            dataTeamNameType,
          }),
        }));

        const normalizedTournament = normalizeTournamentData({ tournament, dataEntityLinks });
        return { matches: normalizedMatches, tournament: normalizedTournament };
      });

      return normalizedMatchesGroupedByTournament;
    }
  } else {
    if (!matches || matches.length === 0 || !teamId) return;
    const normalizedMatches = matches?.map((match: IMatchH2H) => ({
      info: normalizeFootballMatchesH2HGameData({
        game: match,
        dataEntityLinks,
        dataShortStatusType: SHORT_NAME,
        dataTeamNameType,
      }),
      teamWinnerForm: getTeamWinnerForm(teamId, match, dataLabels),
    }));

    return [{ matches: normalizedMatches, tournament: undefined }];
  }
};
